import { Request } from '../';

/**
 * 管理员密码登录
 * @param params
 * @returns {Promise<any>}
 */
const loginStaff = async params => {
  const gql = `mutation loginStaff($form: FormAdminId!, $value: FormLoginValue!) {
  login {
    staffWithPassword(form: $form, value: $value) {
      token
      exp
      expTime
      uid
      level
      cre
      creTime
      psw
      ip
      id
    }
  }
}`;
  return (await Request.request(gql, params, 'user-admin', '管理员登录')).login.staffWithPassword;
};

/**
 * 管理员状态更新
 * @param params
 * @returns {Promise<any>}
 */
const statusStaff = async params => {
  const gql = `query statusStaff {
  me {
    status {
      token
      exp
      expTime
      uid
      level
      cre
      creTime
      psw
      ip
      id
    }
  }
}`;
  return (await Request.request(gql, params, 'user-admin', '状态验证')).me.status;
};

/**
 * 退出登录
 * @param params
 * @returns {Promise<any>}
 */
const logoutStaff = async params => {
  const gql = `mutation logout($agent: String, $dev: String) {
  meExec {
    logout(agent: $agent, dev: $dev)
  }
}`;
  return (await Request.request(gql, params, 'user-admin', '退出登录')).meExec.logout;
};

/**
 * 管理员列表
 * @param params
 * @returns {Promise<any>}
 */
const staffList = async params => {
  const gql = `query staffList($query: FormQuery) {
  me {
    adminList(query: $query) {
      meta {
        limit
        page
        skip
        num
        sort
        keyJson
        count
      }
      data {
        uid
        adminName
        adminId
        user {
          uid
          nickname
          createTime
          updateTime
          status
          numAuth
          username
          email
          locNum
          phone
          unique
          source
          statusEmail
          statusPhone
          statusPsw
          statusQuest
          statusCard
          isTwoFactor
          lang
          auth {
            roles {
              key
              name
              desc
              label
            }
            perms {
              key
              name
              desc
              label
            }
            areas {
              key
              cate
              parent
              index
              code
              name
            }
          }
          profile {
            icon
            name
            phone
            email
            social
            wxIcon
            wxNickname
          }
          weixin {
            cate
            base {
              unionId
              openId
              nickname
              sex
              province
              city
              country
              icon
            }
            wecom {
              unique
              openId
              userid
              name
              mobile
              email
              avatar
              qrCode
              alias
            }
          }
        }
      }
    }
  }
}`;
  return (await Request.request(gql, Request.formQuery(params, 'query'), 'user-admin', '管理员列表')).me.adminList;
};

/**
 * 管理员详情
 * @param params
 * @returns {Promise<any>}
 */
const detailStaff = async params => {
  const gql = `query detailStaff {
  me {
    detail {
      uid
      adminName
      adminId
      user {
        uid
        nickname
        createTime
        updateTime
        status
        numAuth
        username
        email
        locNum
        phone
        unique
        source
        statusEmail
        statusPhone
        statusPsw
        statusQuest
        statusCard
        isTwoFactor
        lang
        auth {
          roles {
            key
            name
            desc
            label
          }
          perms {
            key
            name
            desc
            label
          }
          areas {
            key
            cate
            parent
            index
            code
            name
          }
        }
        profile {
          icon
          name
          phone
          email
          social
          wxIcon
          wxNickname
        }
        weixin {
          cate
          base {
            unionId
            openId
            nickname
            sex
            province
            city
            country
            icon
          }
          wecom {
            unique
            openId
            userid
            name
            mobile
            email
            avatar
            qrCode
            alias
          }
        }
      }
    }
  }
}`;
  return (await Request.request(gql, params, 'user-admin', '管理员详情')).me.detail;
};

/**
 * 新建管理员
 * @param params
 * @returns {Promise<*>}
 */
export const newAdmin = async params => {
  const gql = `mutation newAdmin($form: FormAdmin!, $formPassword: FormUserPassword, $formProfile: FormUserProfile) {
    meExec {
      newAdmin(form: $form, formPassword: $formPassword, formProfile: $formProfile) {
        uid
        adminName
      }
    }
  }`;
  return (await Request.request(gql, params, 'user-admin', '新建管理员')).meExec.newAdmin;
};

/**
 * 编辑管理员
 * @param params
 * @returns {Promise<*>}
 */
export const setAdmin = async params => {
  const gql = `mutation setAdmin($adminID: FormAdminId!, $form: UpdateAdmin, $formPassword: FormUserPassword, $formProfile: FormUserProfile) {
  meEdit {
    setAdmin(adminID: $adminID, form: $form, formPassword: $formPassword, formProfile: $formProfile) {
      uid
      adminName
    }
  }
}`;
  return (await Request.request(gql, params, 'user-admin', '编辑管理员')).meEdit.setAdmin;
};

//
export default {
  loginStaff,
  statusStaff,
  logoutStaff,
  staffList,
  detailStaff,
};
